import $ from "jquery";
export function fadeOutThenNavigate(navigate, container, page) {
    $(container).fadeTo("fast", 0, function() {
        navigate(`/${page}`);
    })
}